import { render, staticRenderFns } from "./settingsPage.vue?vue&type=template&id=1b8c8458&scoped=true"
import script from "./settingsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./settingsPage.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8c8458",
  null
  
)

export default component.exports